import ReactMarkdown from 'react-markdown';

export function Markdown({ linkClassNames, ...rest }: any) {
	return (
		<ReactMarkdown
			{...rest}
			components={{
				a: (props: any) => <Link {...props} className={linkClassNames} href={rest.href || props.href} />
			}}
		/>
	);
}

function Link(props: any) {
	return (
		<a {...props} rel="noopener noreferrer" target="_blank">
			{props.children}
		</a>
	);
}
